import React from 'react'

class VideoLoop extends React.Component {


  constructor(){
    super();
    this.scrollSpy = this.scrollSpy.bind(this)
  }

  scrollSpy(){


      //console.log(this.refs.container.getBoundingClientRect());

      if(this.refs.container.getBoundingClientRect().y<window.innerHeight*.5){
        console.log("Play Video Loop");
        this.refs.container.querySelector('video').play();
        window.removeEventListener('scroll',this.scrollSpy)

      }

  }

  videoLoaded(){

  }

  componentDidMount(){
    setTimeout(()=>{
      window.addEventListener('scroll',this.scrollSpy)
    },600);
  }

  componentWillUnmount(){
    window.removeEventListener('scroll',this.scrollSpy)
  }


  render () {


    let src = this.props.video_file.url

    let fullHeight = this.props.full_height

    console.log("Video Loop",this);

    return(
          <div ref="container">
            <div className={"video-player playing content-row not-fullscreen "+((this.props.full_height)? " full-height " : " keep-aspect")} dangerouslySetInnerHTML={{ __html: `
           <video
              class="actual-video"
             muted
             loop
             paused
             playsinline
             src="${src}"
           />
          ` }}
          />
          </div>
          )
  }
}

export default VideoLoop;



// WEBPACK FOOTER //
// ./src/modules/video/VideoLoop.js